// extracted by css-extract-rspack-plugin
export default {"layout":"zvxQJENIno4FNmDf","treePane":"JfM1XFUjzQ2XjGU6","contentPane":"rvKSgKFtcZ63Ap46","treeWrapper":"s222wXMoB0emCvLd","header":"Yoz7vraYzXcQ913p"};